// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* COMMON STYLES */

body {
	color: #0e0a40;
	width: 100vw !important;
	height: 100vh !important;
}

/*Disable error message from CRA*/
body > iframe {
    display: none;
}

button,
input[type="submit"],
input[type="reset"] {
	background: none;
	color: inherit;
	border: none;
	padding: 0;
	font: inherit;
	cursor: pointer;
	outline: inherit;
}

/*iframe
{
    display: none;
}*/

input:focus,
textarea:focus,
select:focus {
	outline: none;
}

.main-actions {
	margin-bottom: 40px;
}

.hide-container {
	position: relative;
}

main {
	width: 100%;
}

.hide-toggle {
	position: absolute;
	right: 10px;
	bottom: 23px;
	cursor: pointer;
}

.mr-10 {
	margin-right: 10px;
}

.ml-10 {
	margin-left: 10px;
}

.mt-10 {
	margin-top: 10px;
}

.mb-10 {
	margin-bottom: 10px;
}

.mb-25 {
	margin-bottom: 25px;
}

.pr-10 {
	padding-right: 10px;
}

.pl-10 {
	padding-left: 10px;
}

.full-width {
	width: 100%;
}

.justify-right {
	justify-content: right;
}

.push-margin-right {
	margin: 0 0 0 auto;
}

.relative {
	position: relative;
}

.footer-btns-container {
	margin-bottom: 100px;
}

.columns_settings {
	width: 100%;
	display: flex;
	grid-template-columns: 70fr 30fr;
}

.align_form {
	margin-top: 32px;
}

.profile_grid {
	width: 100%;
	display: grid;
	grid-template-columns: 1fr 1fr;
	column-gap: 10px;
}

.create_company_success {
	width: 100%;
	height: 40px;
	background-color: rgba(75, 181, 67, 0.4);
	border-radius: 5px;
	color: white;
	display: flex;
	align-items: center;
	padding: 0 10px 0 10px;
	font-size: 12px;
}

@media (max-width: 600px) {
	.profile_grid {
		grid-template-columns: 1fr;
	}
}

.test {
	width: 100%;
	height: 30px;
	background-color: #3a91f7;
}

.crumb {
	font-size: 12px;
	color: #817ea5;
	font-weight: 600;
	cursor: pointer;
}

.crumb_arrow {
	font-size: 12px;
	color: #817ea5;
	font-weight: 600;
	margin-left: 5px;
	margin-right: 5px;
}

@media (max-width: 600px) {
	.crumb {
		font-size: 12px;
	}

	.crumb_arrow {
		font-size: 12px;
	}

	.crumb_current {
		font-size: 12px;
	}
}

.crumb_current {
	font-size: 12px;
	color: #0e0a40;
	font-weight: 600;
	cursor: not-allowed;
}

.left_edge {
	width: 15vw;
}

.row {
	display: flex;
	align-items: center;
}

.center {
	display: flex;
	justify-content: center;
	align-items: center;
}

.column_center {
	display: flex;
	flex-direction: column;
	align-items: center;
}

.space-between {
	display: flex;
	justify-content: space-between;
	align-items: center;
}

.space-between-no-center {
	display: flex;
	justify-content: space-between;
}

.flex-end {
	width: 100%;
	display: flex;
	justify-content: flex-end;
}

.flex-end-center {
	width: 100%;
	display: flex;
	justify-content: flex-end;
	align-items: center;
}

h2 {
	font-size: 30px;
	color: #0e0a40;
	font-weight: 800;
}

strong {
	padding-right: 7px;
}

.login_logo {
	position: absolute;
	width: 150px;
	left: 20px;
	top: 20px;
}

.main_container {
	overflow-y: scroll;
	height: calc(100vh - 100px);
}

/* Buttons */
.primary {
	background-color: #fd552b;
	color: #ffffff;
	font-size: 0.9rem;
}

.login_btn {
	background: rgb(253, 85, 43);
	background: linear-gradient(270deg,
			rgba(253, 85, 43, 1) 0%,
			rgba(253, 85, 43, 1) 74%,
			rgba(253, 43, 124, 1) 100%);
	filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#fd552b", endColorstr="#fd2b7c", GradientType=1);
	color: #ffffff;
}

.primary:hover {
	background: #c64422;
}

.secondary {
	background-color: #edeef4;
	color: #000000;
	font-weight: 600;
}

.secondary:hover {
	background: #dddddd;
}

.tertiary {
	background-color: #9facc7;
	color: #ffffff;
}

.success:hover {
	background-color: #259679;
}

.success {
    background-color: #2bb992;
    color: #ffffff;
}

.white {
	background-color: #ffffff;
}

.btn_lg {
	height: 41px !important;
}

.with_tooltip:hover+.tooltip_black {
	display: block;
}

.tooltip_black {
	display: none;
	margin-top: 0.5rem;
	background-color: rgba(0, 0, 0, 0.35);
	color: white;
	padding: 7px;
	border-radius: 5px;
	font-family: Montserrat, sans-serif;
	font-size: 12px;
}

.onboarding_input_grid {
	display: grid;
	grid-template-columns: 1fr 1fr 1fr 1fr;
	grid-gap: 10px;
	position: relative;
}

.onboarding_btn {
	position: absolute;
	right: -50px;
	top: 41px;
}

.onboarding_branch_grid {
	display: grid;
	grid-template-columns: 0.8fr 0.8fr 0.8fr 1.6fr;
	grid-gap: 10px;
	position: relative;
}

.onboarding_link {
	cursor: pointer;
	font-size: 14px;
	color: #8f9bb3;
	margin-right: 1rem;
}

.onboarding_save_btn {
	min-width: 66px;
	padding-left: 7px;
	padding-right: 7px;
	height: 40px;
	display: flex;
	justify-content: center;
	align-items: center;
	font-size: 14px;
	background-color: rgba(143, 155, 179, 0.12);
	border: 1px solid #9da9c4;
	border-radius: 5px;
	color: #9da9c4;
	margin-right: 1rem;
}

.onboarding_save_btn:hover {
	background-color: rgba(143, 155, 179, 0.3);
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
	-webkit-appearance: none;
	margin: 0;
}

/* Firefox */
input[type="number"] {
	-moz-appearance: textfield;
}

.chart_blocker {
	width: 100%;
	height: 100%;
	background-color: transparent;
	position: absolute;
	z-index: 9999;
}

.input_number_box {
	position: relative;
}

.arrow_up {
	width: 25px;
	height: 23px;
	background-color: rgba(228, 233, 242, 0.77);
	position: absolute;
	right: 1px;
	display: flex;
	justify-content: center;
	align-items: center;
	top: 1px;
	cursor: pointer;
	border-radius: 0px 5px 0 0px;
}

.arrow_bottom {
	width: 25px;
	height: 23px;
	background-color: rgba(228, 233, 242, 0.77);
	position: absolute;
	right: 1px;
	display: flex;
	justify-content: center;
	align-items: center;
	top: 26px;
	cursor: pointer;
	border-radius: 0px 0px 5px 0px;
}

.arrow_bottom>img {
	transform: rotateZ(-180deg);
}

/* Text classes */
.rem-08 {
	font-size: 0.8rem;
}

.text-center {
	text-align: center;
}

.text-right {
	text-align: right;
}

.employee_header_row {
	display: flex;
	justify-content: flex-end;
	align-items: center;
}

.min-w {
	width: min-content;
}

.dashboard_box_padding {
	width: 100%;
	height: 100%;
	padding: 29px 42px 36px 25px;
	position: relative;
}

@media (max-width: 600px) {
	.dashboard_box_padding {
		padding: 16px;
	}

	.employee_header_row {
		display: flex;
		justify-content: flex-end;
		width: 100%;
	}
}

.select-react div.control {
	height: 50px;
	border: 1px solid #cde1eb;
}

.line {
	position: relative;
	width: 100%;
	height: 1px;
	background-color: #e3ecff;
	margin-top: 10px;
	margin-bottom: 35px;
}

.line_element {
	position: absolute;
	left: 0;
	top: -1px;
	width: 40px;
	height: 3px;
	background-color: #e0e9f5;
}

.table_line {
	margin-bottom: 27px;
}

.table_row {
	font-family: Montserrat, sans-serif;
	width: 100%;
	height: 74px;
	align-items: center;
	border: 1px solid #f3f3f3;
	padding: 15px;
	font-size: 16px;
	font-weight: 500;
	border-radius: 4px;
	margin-bottom: 4px;
	color: #000000;
}

.standard-padding-l {
	padding-left: 40px;
}

.standard-margin-l {
	margin-left: 40px;
}

/* SEARCH BOX */
.search_container {
	min-width: 450px;
	border-radius: 11px 10px 10px 11px;
	display: flex;
	position: relative;
}

@media (max-width: 900px) {
	.search_container {
		width: 100%;
		min-width: 200px;
		border-radius: 11px 10px 10px 11px;
		display: flex;
	}
}

@media (max-width: 700px) {
	.header_orders {
		display: flex;
		flex-direction: column;
		align-items: flex-start;
	}
}

.dark_search {
	height: 45px;
	background-color: #edeef4;
}

.light_search {
	height: 47px;
	background-color: #ffffff;
	border: 1px #e3e5f1 solid;
}

.search_container input::placeholder {
	font-family: "Montserrat", sans-serif;
	font-size: 12px;
	font-weight: 500;
	color: rgba(124, 130, 138, 0.38);
}

.search_button {
	height: 45px;
	width: 50px;
	background-color: rgba(81, 93, 167, 0.16);
	border-radius: 10px;
	cursor: pointer;
}

.search_clear_button {
	height: 20px;
	width: 20px;
	background-color: rgba(81, 93, 167, 0.16);
	border-radius: 50%;
	cursor: pointer;
	display: flex;
	justify-content: center;
	align-items: center;
	position: absolute;
	right: 20px;
	top: 12px;
}

.search_clear_button>img {
	width: 8px;
	height: 8px;
}

.search_container input {
	width: 100%;
	-webkit-appearance: none;
	border: none;
	background-color: transparent;
	font-size: 14px;
	padding-left: 15px;
	color: rgba(124, 130, 138, 1);
}

.header_search_responsive_show {
	display: none;
}

.header_search_responsive_hide {
	display: none;
}

.search_icon {
	width: 18px;
	height: 18px;
}

/* UPLOAD IMAGE COMPONENT */

.pdf_upload {
	min-width: 205px;
	width: -moz-fit-content;
	width: fit-content;
	position: relative;
	cursor: pointer;
	border-radius: 7px;
}

.pdf_upload:hover {
	background: #c64422
}

.pdf_upload_image {
	width: 200px;
	height: 200px;
	background-size: cover;
	background-position: center;
}


.image_upload {
	position: relative;
	width: 262px;
	height: 262px;
	border-radius: 50%;
	border: 2px solid #dee1e7;
	background-size: cover;
	background-position: center;
}

@media (max-width: 450px) {
	.image_upload-center {
		display: flex;
		justify-content: center;
	}
}

.upload_image {
	position: absolute;
	width: 100%;
	height: 100%;
	border-radius: 50%;
	background-size: contain;
	background-position: center;
	background-repeat: no-repeat;
	top: 0;
	left: 0;
}

.upload_user {
	position: absolute;
	width: 100%;
	height: 100%;
	border-radius: 50%;
	background-size: cover;
	background-repeat: no-repeat;
	top: 0;
	left: 0;
}

.hide-file-input {
	position: absolute;
	width: 58px;
	height: 58px;
	border-radius: 50%;
	right: 0;
	z-index: 2;
	opacity: 0;
}

.hide-file-input:hover {
	cursor: "pointer"
}

.custom_file_input {
	position: absolute;
	width: 58px;
	height: 58px;
	border-radius: 50%;
	background-color: #9facc7;
	right: 0;
	z-index: 1;
}

.custom_file_input>img {
	width: 25px;
}

.side_product_title {
	font-size: 16px;
	padding-left: 15px;
	font-weight: 700;
}

.plans_wrapper {
	width: 100%;
	max-width: 1400px;
}

.invoice-status {
	color: rgba(51, 51, 51, 1);
	font-weight: 700;
	font-size: 22px;
	border-bottom: 2px solid #e0e0e7;
	padding-bottom: 10px;
    margin-bottom: 20px;
}

.invoice_comment_container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 7px;
    background-color: rgba(13, 150, 131, 0.08);
    padding: 7px;
    border-radius: 5px;
}

.invoice_comment_container > p {
    font-size: 14px;
}

.invoice_comment_container > div {
    max-width: 300px;
    font-size: 12px;
    text-align: end;
}

.invoice-ocr-error {
    display: flex;
    align-content: center;
    gap: 3px;
    margin-top: 14px;
}

.invoice-ocr-comment {
    margin-top: 20px;
}

.invoice-ocr-comment > div {
    display: flex;
    align-items: center;
    gap: 14px;
}

.invoice-ocr-comment > div > div > p:first-child {
    font-size: 14px;
    font-weight: bold;
    display: flex;
    align-items: center;
}

.invoice-ocr-comment > div > div > p:first-child > span {
    font-size: 12px;
    font-weight: normal;
    margin-left: 7px;
    color: #0d9683;
}

.invoice-ocr-comment > div > div > p:last-child {
    font-size: 14px;
    margin-top: 5px;
}

.invoice-ocr-comment-tooltip {
    height: 20px;
}

.invoice-ocr-error > img {
    width: 16px;
    height: 16px;
    /*margin-top: auto;
    margin-bottom: auto;*/
}

.invoice-ocr-error > p {
    font-size: 14px;
    color: rgba(222, 57, 73, 1);
    margin-bottom: 0;
}

.invoice_detail_value {
    font-size: 18px;
    font-weight: 400;
}

.invoice_detail_title {
    font-size: 14px;
    font-weight: 400;
}

.invoice_detail_next_btn {
    height: 40px;
    display: flex;
    align-items: center;
    padding-left: 15px;
    padding-right: 15px;
    background-color: rgba(156, 154, 167, 1);
    border-radius: 5px;
    color: #FFFFFF;
}

.invoice_detail_next_btn:hover {
    background-color: rgb(121, 119, 131);
}

.invoice_detail_next_btn > img {
    width: 24px;
}

.invoice_detail_next_btn > p {
    font-size: 14px;
    font-weight: 500;
    margin-left: 5px;
}

.invoice_detail_value_bold {
    font-size: 20px;
    font-weight: 700;
}

.invoice_image {
	width: 90%;
}

.invoice-header {
	color: #001940;
	font-size: 1.2rem;
	font-weight: 700;
	display: flex;
	justify-content: space-between;
	border-bottom: 1px solid #e0e0e7;
	padding-bottom: 10px;
}

.invoice-data {
	color: #001940;
	font-size: 1rem;
	font-weight: 400;
	display: flex;
	justify-content: space-between;
}

.invoice-amount {
	color: #767493;
	font-size: 1rem;
	font-weight: 400;
	display: flex;
	justify-content: space-between;
	line-height: 37px;
}

.csv_reader {
	position: absolute;
	left: 0;
	top: 0;
}

.csv_label {
	display: none;
}

.csv_upload_wrapper {
	background-color: #f0b619;
	width: 100%;
	height: 40px;
	opacity: 0;
}

.csv_btn {
	display: flex;
	justify-content: center;
	align-items: center;
}

/* COLORS */
.red {
	background-color: red;
}

.green {
	background-color: #00c18d;
}

/* SIZES */
.pc80 {
	width: 80%;
}

/* FONTS */
h4 {
	font-size: 16px;
	font-family: "Montserrat", sans-serif;
	font-weight: 600;
	color: #292452;
}

/* SHADOW */
.shadow {
	box-shadow: rgba(149, 157, 165, 0.2) 0 8px 24px;
}

.input_error {
	font-size: 14px;
	text-align: right;
	margin-top: -15px;
	color: rgba(151, 57, 55, 0.7);
}

.input_warning {
	position: absolute;
	font-size: 10px;
	text-align: left;
	bottom: -1px;
	color: rgba(151, 57, 55, 0.7);
}

/* TOASTS */
.Toastify__toast--success {
	background: rgb(222, 242, 214);
	color: rgb(130, 105, 56);
}

.Toastify__toast--warning {
	background: rgb(248, 243, 215);
	color: rgb(140, 57, 58);
}

.Toastify__toast--error {
	background: rgb(235, 200, 196);
	color: rgb(90, 110, 82);
}

.Toastify__close-button>svg {
	fill: rgb(140, 57, 58);
}

@media (max-width: 800px) {
	.pending_box {
		max-width: 96vw;
	}
}

.header_plans {
	display: flex;
	justify-content: space-between;
	align-items: center;
}

@media (max-width: 700px) {
	.header_plans {
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		gap: 10px;
	}
}

.companies_sub_title {
	text-align: center;
	margin-top: 0.5rem;
	font-size: 14px;
	color: #37454d;
}

.companies_table_container {
	margin-top: 3rem;
	background-color: white;
	padding-top: 3rem;
	display: flex;
	flex-direction: column;
	align-items: center;
	padding-bottom: 3rem;
}

.companies_table_container>img {
	width: 300px;
	max-width: 50vw;
}

.companies_table_container>h3 {
	margin-top: 1rem;
	font-size: 18px;
	font-weight: 600;
}

.companies_table_container>p {
	margin-top: 0.5rem;
	font-size: 14px;
	font-weight: 500;
	color: #37454d;
}

.oboarding_container {
	max-width: 860px;
	margin-left: auto;
	margin-right: auto;
}

.onboarding_sub_title {
	font-size: 11px;
	color: #333333;
}

.space-between_onboarding {
	display: flex;
	justify-content: space-between;
	align-items: center;
	border-bottom: 1px solid rgba(143, 155, 179, 0.26);
	padding-bottom: 0.5rem;
}

/*.settings_tab {
    margin-top: 30px;
}*/

.perm_table_box {
	background-color: white;
}

.sub_title {
	font-size: 16px;
	font-weight: 500;
	color: rgba(0, 0, 0, 0.8);
}

@media (max-width: 700px) {
	.sub_title {
		max-width: 40vw;
		margin-bottom: 1rem;
		font-size: 12px;
	}
}

.space-between_plans {
	display: flex;
	justify-content: space-between;
	align-items: center;
}

@media (max-width: 450px) {
	.space-between_plans {
		display: block;
	}
}

.employee_select_row {
	display: flex;
	align-items: center;
}

@media (max-width: 600px) {
	.employee_select_row {
		display: block;
	}
}

.form_radio input[type="radio"] {
	display: none;
}

.form_radio label {
	display: inline-block;
	cursor: pointer;
	position: relative;
	padding-left: 25px;
	margin-right: 0px;
	line-height: 18px;
	-webkit-user-select: none;
	        user-select: none;
	font-size: 14px;
}

.form_radio label:before {
	content: "";
	display: inline-block;
	width: 16px;
	min-width: 14px;
	min-height: 14px;
	max-width: 14px;
	max-height: 14px;
	height: 16px;
	position: absolute;
	left: 0;
	bottom: 1px;
	border-radius: 50%;
	border: 1px solid #767493;
}

.customReactSelectMenu {
	background-color: white;
}

.permission_select_btn_box {
	width: 100%;
	padding: 10px;
}

/* Checked */
.form_radio input[type="radio"]:checked+label:before {
	background: radial-gradient(#767493 50%, rgba(255, 0, 0, 0) 51%);
}

/* Hover */
.form_radio label:hover:before {
	filter: brightness(120%);
}

/* Disabled */
.form_radio input[type="radio"]:disabled+label:before {
	filter: grayscale(100%);
}

.cookie_container {
	padding-left: 20%;
	padding-right: 20%;
	min-height: 200px;
	color: white;
	background-color: #070948 !important;
	padding-top: 20px;
}

.cookie_title {
	font-size: 16px;
	font-weight: 600;
}

.cookie_text {
	font-size: 12px;
	margin-top: 1rem;
}

.cookie_link {
	color: #f67b44;
	text-decoration: none;
	font-weight: 600;
}

.cookie_button {
	position: absolute;
	bottom: 20px;
	background-color: #f67b44 !important;
	color: white !important;
	border-radius: 30px !important;
	font-weight: 600;
	padding: 10px 15px 10px 15px !important;
}

@media (max-width: 900px) {
	.cookie_button {
		position: relative;
	}
}

@media (max-width: 700px) {
	.cookie_container {
		padding-left: 16px;
		padding-right: 16px;
	}
}

.footer_link {
	position: absolute;
	bottom: 10px;
	font-size: 12px;
	font-weight: 600;
	color: white;
	text-decoration: none;
	margin-left: 1rem;
}

@media (max-width: 700px) {
	html {
		font-size: 70%;
	}
}

.update_info_arrow {
	width: 10px;
	margin-left: 5px;
	margin-right: 5px;
}

.update_info_img {
	min-width: 40px;
	min-height: 40px;
	width: 40px;
	height: 40px;
	border-radius: 50%;
	background-color: black;
	background-size: cover;
}

.update_info_img.small {
	min-width: 30px;
	min-height: 30px;
	width: 30px;
	height: 30px;
}

.invoice_status_box {
	position: relative;
	margin-right: 0.5rem;
}

.badge {
	width: max-content;
	padding: 5px 10px;
	border-radius: 3px;
	font-weight: 600;
	letter-spacing: 0.5px;
}

.accept_badge {
	background-color: rgba(0, 182, 155, 0.25);
	color: #0d9683;
}

.yellow_badge {
	background-color: #FFF3CD;
	color: #856404;
}

.blue_badge {
	background-color: #CCE5FF;
	color: #004085;
}

.status_dot {
	width: 15px;
	height: 15px;
	border-radius: 50%;
	margin-left: auto;
	margin-right: 8px;
	float: left;
}

.status_dot.red {
	background-color: #ff0033;
}

.status_dot.green {
	background-color: #50C878;
}

.status_dot.yellow {
	background-color: #FFC33C;
}

.pending_badge {
	color: #f2a338;
	background-color: rgba(255, 236, 206, 0.8);
}

.reject_badge {
	color: #e56a5f;
	background-color: rgba(255, 162, 157, 0.5);
}

.badge.small {
	width: max-content;
	padding: 2px 5px;
	border-radius: 2px;
	font-weight: 600;
	letter-spacing: 0.2px;
	font-size: 11px;
}

.notification_mark_text {
	font-size: 12px;
	font-weight: 600;
	cursor: pointer;
	color: #1ec0a6;
}

/* Rounded sliders */
.slider_switch.round {
	border-radius: 34px;
	box-shadow: rgba(149, 157, 165, 0.4) 0 8px 24px;
}

.slider_switch.round:before {
	border-radius: 50%;
}

.text_area {
	border: 1px solid rgba(14, 10, 64, 0.15);
	border-radius: 5px;
	resize: none;
	padding: 10px;
	font-size: 14px;
	font-family: Montserrat;
    margin-left: 0!important;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,kBAAkB;;AAElB;CACC,cAAc;CACd,uBAAuB;CACvB,wBAAwB;AACzB;;AAEA,iCAAiC;AACjC;IACI,aAAa;AACjB;;AAEA;;;CAGC,gBAAgB;CAChB,cAAc;CACd,YAAY;CACZ,UAAU;CACV,aAAa;CACb,eAAe;CACf,gBAAgB;AACjB;;AAEA;;;EAGE;;AAEF;;;CAGC,aAAa;AACd;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,YAAY;CACZ,eAAe;AAChB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,WAAW;CACX,aAAa;CACb,gCAAgC;AACjC;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,WAAW;CACX,aAAa;CACb,8BAA8B;CAC9B,gBAAgB;AACjB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,wCAAwC;CACxC,kBAAkB;CAClB,YAAY;CACZ,aAAa;CACb,mBAAmB;CACnB,sBAAsB;CACtB,eAAe;AAChB;;AAEA;CACC;EACC,0BAA0B;CAC3B;AACD;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,yBAAyB;AAC1B;;AAEA;CACC,eAAe;CACf,cAAc;CACd,gBAAgB;CAChB,eAAe;AAChB;;AAEA;CACC,eAAe;CACf,cAAc;CACd,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;AAClB;;AAEA;CACC;EACC,eAAe;CAChB;;CAEA;EACC,eAAe;CAChB;;CAEA;EACC,eAAe;CAChB;AACD;;AAEA;CACC,eAAe;CACf,cAAc;CACd,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,aAAa;CACb,mBAAmB;AACpB;;AAEA;CACC,aAAa;CACb,uBAAuB;CACvB,mBAAmB;AACpB;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,mBAAmB;AACpB;;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,mBAAmB;AACpB;;AAEA;CACC,aAAa;CACb,8BAA8B;AAC/B;;AAEA;CACC,WAAW;CACX,aAAa;CACb,yBAAyB;AAC1B;;AAEA;CACC,WAAW;CACX,aAAa;CACb,yBAAyB;CACzB,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,UAAU;CACV,SAAS;AACV;;AAEA;CACC,kBAAkB;CAClB,2BAA2B;AAC5B;;AAEA,YAAY;AACZ;CACC,yBAAyB;CACzB,cAAc;CACd,iBAAiB;AAClB;;AAEA;CACC,4BAA4B;CAS5B;;;8BAG6B;CAC7B,kHAAkH;CAClH,cAAc;AACf;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,yBAAyB;CACzB,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,yBAAyB;CACzB,cAAc;AACf;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,aAAa;CACb,kBAAkB;CAClB,qCAAqC;CACrC,YAAY;CACZ,YAAY;CACZ,kBAAkB;CAClB,mCAAmC;CACnC,eAAe;AAChB;;AAEA;CACC,aAAa;CACb,sCAAsC;CACtC,cAAc;CACd,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,SAAS;AACV;;AAEA;CACC,aAAa;CACb,8CAA8C;CAC9C,cAAc;CACd,kBAAkB;AACnB;;AAEA;CACC,eAAe;CACf,eAAe;CACf,cAAc;CACd,kBAAkB;AACnB;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,kBAAkB;CAClB,YAAY;CACZ,aAAa;CACb,uBAAuB;CACvB,mBAAmB;CACnB,eAAe;CACf,2CAA2C;CAC3C,yBAAyB;CACzB,kBAAkB;CAClB,cAAc;CACd,kBAAkB;AACnB;;AAEA;CACC,0CAA0C;AAC3C;;AAEA,gCAAgC;AAChC;;CAEC,wBAAwB;CACxB,SAAS;AACV;;AAEA,YAAY;AACZ;CACC,0BAA0B;AAC3B;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,6BAA6B;CAC7B,kBAAkB;CAClB,aAAa;AACd;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,2CAA2C;CAC3C,kBAAkB;CAClB,UAAU;CACV,aAAa;CACb,uBAAuB;CACvB,mBAAmB;CACnB,QAAQ;CACR,eAAe;CACf,4BAA4B;AAC7B;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,2CAA2C;CAC3C,kBAAkB;CAClB,UAAU;CACV,aAAa;CACb,uBAAuB;CACvB,mBAAmB;CACnB,SAAS;CACT,eAAe;CACf,8BAA8B;AAC/B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA,iBAAiB;AACjB;CACC,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,aAAa;CACb,yBAAyB;CACzB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,4BAA4B;CAC5B,kBAAkB;AACnB;;AAEA;CACC;EACC,aAAa;CACd;;CAEA;EACC,aAAa;EACb,yBAAyB;EACzB,WAAW;CACZ;AACD;;AAEA;CACC,YAAY;CACZ,yBAAyB;AAC1B;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,WAAW;CACX,yBAAyB;CACzB,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,OAAO;CACP,SAAS;CACT,WAAW;CACX,WAAW;CACX,yBAAyB;AAC1B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mCAAmC;CACnC,WAAW;CACX,YAAY;CACZ,mBAAmB;CACnB,yBAAyB;CACzB,aAAa;CACb,eAAe;CACf,gBAAgB;CAChB,kBAAkB;CAClB,kBAAkB;CAClB,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,iBAAiB;AAClB;;AAEA,eAAe;AACf;CACC,gBAAgB;CAChB,kCAAkC;CAClC,aAAa;CACb,kBAAkB;AACnB;;AAEA;CACC;EACC,WAAW;EACX,gBAAgB;EAChB,kCAAkC;EAClC,aAAa;CACd;AACD;;AAEA;CACC;EACC,aAAa;EACb,sBAAsB;EACtB,uBAAuB;CACxB;AACD;;AAEA;CACC,YAAY;CACZ,yBAAyB;AAC1B;;AAEA;CACC,YAAY;CACZ,yBAAyB;CACzB,yBAAyB;AAC1B;;AAEA;CACC,qCAAqC;CACrC,eAAe;CACf,gBAAgB;CAChB,gCAAgC;AACjC;;AAEA;CACC,YAAY;CACZ,WAAW;CACX,yCAAyC;CACzC,mBAAmB;CACnB,eAAe;AAChB;;AAEA;CACC,YAAY;CACZ,WAAW;CACX,yCAAyC;CACzC,kBAAkB;CAClB,eAAe;CACf,aAAa;CACb,uBAAuB;CACvB,mBAAmB;CACnB,kBAAkB;CAClB,WAAW;CACX,SAAS;AACV;;AAEA;CACC,UAAU;CACV,WAAW;AACZ;;AAEA;CACC,WAAW;CACX,wBAAwB;CACxB,YAAY;CACZ,6BAA6B;CAC7B,eAAe;CACf,kBAAkB;CAClB,6BAA6B;AAC9B;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,WAAW;CACX,YAAY;AACb;;AAEA,2BAA2B;;AAE3B;CACC,gBAAgB;CAChB,uBAAkB;CAAlB,kBAAkB;CAClB,kBAAkB;CAClB,eAAe;CACf,kBAAkB;AACnB;;AAEA;CACC;AACD;;AAEA;CACC,YAAY;CACZ,aAAa;CACb,sBAAsB;CACtB,2BAA2B;AAC5B;;;AAGA;CACC,kBAAkB;CAClB,YAAY;CACZ,aAAa;CACb,kBAAkB;CAClB,yBAAyB;CACzB,sBAAsB;CACtB,2BAA2B;AAC5B;;AAEA;CACC;EACC,aAAa;EACb,uBAAuB;CACxB;AACD;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,wBAAwB;CACxB,2BAA2B;CAC3B,4BAA4B;CAC5B,MAAM;CACN,OAAO;AACR;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,sBAAsB;CACtB,4BAA4B;CAC5B,MAAM;CACN,OAAO;AACR;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,QAAQ;CACR,UAAU;CACV,UAAU;AACX;;AAEA;CACC;AACD;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,yBAAyB;CACzB,QAAQ;CACR,UAAU;AACX;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,eAAe;CACf,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,WAAW;CACX,iBAAiB;AAClB;;AAEA;CACC,0BAA0B;CAC1B,gBAAgB;CAChB,eAAe;CACf,gCAAgC;CAChC,oBAAoB;IACjB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,0CAA0C;IAC1C,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,QAAQ;IACR,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ;yBACqB;AACzB;;AAEA;IACI,eAAe;IACf,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,wCAAwC;IACxC,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,cAAc;CACd,iBAAiB;CACjB,gBAAgB;CAChB,aAAa;CACb,8BAA8B;CAC9B,gCAAgC;CAChC,oBAAoB;AACrB;;AAEA;CACC,cAAc;CACd,eAAe;CACf,gBAAgB;CAChB,aAAa;CACb,8BAA8B;AAC/B;;AAEA;CACC,cAAc;CACd,eAAe;CACf,gBAAgB;CAChB,aAAa;CACb,8BAA8B;CAC9B,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;CAClB,OAAO;CACP,MAAM;AACP;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,yBAAyB;CACzB,WAAW;CACX,YAAY;CACZ,UAAU;AACX;;AAEA;CACC,aAAa;CACb,uBAAuB;CACvB,mBAAmB;AACpB;;AAEA,WAAW;AACX;CACC,qBAAqB;AACtB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA,UAAU;AACV;CACC,UAAU;AACX;;AAEA,UAAU;AACV;CACC,eAAe;CACf,qCAAqC;CACrC,gBAAgB;CAChB,cAAc;AACf;;AAEA,WAAW;AACX;CAEC,+CAA+C;AAChD;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,iBAAiB;CACjB,6BAA6B;AAC9B;;AAEA;CACC,kBAAkB;CAClB,eAAe;CACf,gBAAgB;CAChB,YAAY;CACZ,6BAA6B;AAC9B;;AAEA,WAAW;AACX;CACC,8BAA8B;CAC9B,wBAAwB;AACzB;;AAEA;CACC,8BAA8B;CAC9B,uBAAuB;AACxB;;AAEA;CACC,8BAA8B;CAC9B,uBAAuB;AACxB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC;EACC,eAAe;CAChB;AACD;;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,mBAAmB;AACpB;;AAEA;CACC;EACC,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;CACV;AACD;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,eAAe;CACf,cAAc;AACf;;AAEA;CACC,gBAAgB;CAChB,uBAAuB;CACvB,iBAAiB;CACjB,aAAa;CACb,sBAAsB;CACtB,mBAAmB;CACnB,oBAAoB;AACrB;;AAEA;CACC,YAAY;CACZ,eAAe;AAChB;;AAEA;CACC,gBAAgB;CAChB,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,eAAe;CACf,gBAAgB;CAChB,cAAc;AACf;;AAEA;CACC,gBAAgB;CAChB,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,eAAe;CACf,cAAc;AACf;;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,mBAAmB;CACnB,kDAAkD;CAClD,sBAAsB;AACvB;;AAEA;;EAEE;;AAEF;CACC,uBAAuB;AACxB;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,yBAAyB;AAC1B;;AAEA;CACC;EACC,eAAe;EACf,mBAAmB;EACnB,eAAe;CAChB;AACD;;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,mBAAmB;AACpB;;AAEA;CACC;EACC,cAAc;CACf;AACD;;AAEA;CACC,aAAa;CACb,mBAAmB;AACpB;;AAEA;CACC;EACC,cAAc;CACf;AACD;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,qBAAqB;CACrB,eAAe;CACf,kBAAkB;CAClB,kBAAkB;CAClB,iBAAiB;CACjB,iBAAiB;CACjB,yBAAiB;SAAjB,iBAAiB;CACjB,eAAe;AAChB;;AAEA;CACC,WAAW;CACX,qBAAqB;CACrB,WAAW;CACX,eAAe;CACf,gBAAgB;CAChB,eAAe;CACf,gBAAgB;CAChB,YAAY;CACZ,kBAAkB;CAClB,OAAO;CACP,WAAW;CACX,kBAAkB;CAClB,yBAAyB;AAC1B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,WAAW;CACX,aAAa;AACd;;AAEA,YAAY;AACZ;CACC,gEAAgE;AACjE;;AAEA,UAAU;AACV;CACC,wBAAwB;AACzB;;AAEA,aAAa;AACb;CACC,uBAAuB;AACxB;;AAEA;CACC,iBAAiB;CACjB,kBAAkB;CAClB,iBAAiB;CACjB,YAAY;CACZ,oCAAoC;CACpC,iBAAiB;AAClB;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,cAAc;CACd,qBAAqB;CACrB,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,oCAAoC;CACpC,uBAAuB;CACvB,8BAA8B;CAC9B,gBAAgB;CAChB,uCAAuC;AACxC;;AAEA;CACC;EACC,kBAAkB;CACnB;AACD;;AAEA;CACC;EACC,kBAAkB;EAClB,mBAAmB;CACpB;AACD;;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,eAAe;CACf,gBAAgB;CAChB,YAAY;CACZ,qBAAqB;CACrB,iBAAiB;AAClB;;AAEA;CACC;EACC,cAAc;CACf;AACD;;AAEA;CACC,WAAW;CACX,gBAAgB;CAChB,iBAAiB;AAClB;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,uBAAuB;CACvB,sBAAsB;AACvB;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,WAAW;CACX,YAAY;AACb;;AAEA;CACC,kBAAkB;CAClB,oBAAoB;AACrB;;AAEA;CACC,kBAAkB;CAClB,iBAAiB;CACjB,kBAAkB;CAClB,gBAAgB;CAChB,qBAAqB;AACtB;;AAEA;CACC,yCAAyC;CACzC,cAAc;AACf;;AAEA;CACC,yBAAyB;CACzB,cAAc;AACf;;AAEA;CACC,yBAAyB;CACzB,cAAc;AACf;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,iBAAiB;CACjB,iBAAiB;CACjB,WAAW;AACZ;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,cAAc;CACd,0CAA0C;AAC3C;;AAEA;CACC,cAAc;CACd,0CAA0C;AAC3C;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,kBAAkB;CAClB,gBAAgB;CAChB,qBAAqB;CACrB,eAAe;AAChB;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,eAAe;CACf,cAAc;AACf;;AAEA,oBAAoB;AACpB;CACC,mBAAmB;CAEnB,+CAA+C;AAChD;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,wCAAwC;CACxC,kBAAkB;CAClB,YAAY;CACZ,aAAa;CACb,eAAe;CACf,uBAAuB;IACpB,wBAAwB;AAC5B","sourcesContent":["/* COMMON STYLES */\n\nbody {\n\tcolor: #0e0a40;\n\twidth: 100vw !important;\n\theight: 100vh !important;\n}\n\n/*Disable error message from CRA*/\nbody > iframe {\n    display: none;\n}\n\nbutton,\ninput[type=\"submit\"],\ninput[type=\"reset\"] {\n\tbackground: none;\n\tcolor: inherit;\n\tborder: none;\n\tpadding: 0;\n\tfont: inherit;\n\tcursor: pointer;\n\toutline: inherit;\n}\n\n/*iframe\n{\n    display: none;\n}*/\n\ninput:focus,\ntextarea:focus,\nselect:focus {\n\toutline: none;\n}\n\n.main-actions {\n\tmargin-bottom: 40px;\n}\n\n.hide-container {\n\tposition: relative;\n}\n\nmain {\n\twidth: 100%;\n}\n\n.hide-toggle {\n\tposition: absolute;\n\tright: 10px;\n\tbottom: 23px;\n\tcursor: pointer;\n}\n\n.mr-10 {\n\tmargin-right: 10px;\n}\n\n.ml-10 {\n\tmargin-left: 10px;\n}\n\n.mt-10 {\n\tmargin-top: 10px;\n}\n\n.mb-10 {\n\tmargin-bottom: 10px;\n}\n\n.mb-25 {\n\tmargin-bottom: 25px;\n}\n\n.pr-10 {\n\tpadding-right: 10px;\n}\n\n.pl-10 {\n\tpadding-left: 10px;\n}\n\n.full-width {\n\twidth: 100%;\n}\n\n.justify-right {\n\tjustify-content: right;\n}\n\n.push-margin-right {\n\tmargin: 0 0 0 auto;\n}\n\n.relative {\n\tposition: relative;\n}\n\n.footer-btns-container {\n\tmargin-bottom: 100px;\n}\n\n.columns_settings {\n\twidth: 100%;\n\tdisplay: flex;\n\tgrid-template-columns: 70fr 30fr;\n}\n\n.align_form {\n\tmargin-top: 32px;\n}\n\n.profile_grid {\n\twidth: 100%;\n\tdisplay: grid;\n\tgrid-template-columns: 1fr 1fr;\n\tcolumn-gap: 10px;\n}\n\n.create_company_success {\n\twidth: 100%;\n\theight: 40px;\n\tbackground-color: rgba(75, 181, 67, 0.4);\n\tborder-radius: 5px;\n\tcolor: white;\n\tdisplay: flex;\n\talign-items: center;\n\tpadding: 0 10px 0 10px;\n\tfont-size: 12px;\n}\n\n@media (max-width: 600px) {\n\t.profile_grid {\n\t\tgrid-template-columns: 1fr;\n\t}\n}\n\n.test {\n\twidth: 100%;\n\theight: 30px;\n\tbackground-color: #3a91f7;\n}\n\n.crumb {\n\tfont-size: 12px;\n\tcolor: #817ea5;\n\tfont-weight: 600;\n\tcursor: pointer;\n}\n\n.crumb_arrow {\n\tfont-size: 12px;\n\tcolor: #817ea5;\n\tfont-weight: 600;\n\tmargin-left: 5px;\n\tmargin-right: 5px;\n}\n\n@media (max-width: 600px) {\n\t.crumb {\n\t\tfont-size: 12px;\n\t}\n\n\t.crumb_arrow {\n\t\tfont-size: 12px;\n\t}\n\n\t.crumb_current {\n\t\tfont-size: 12px;\n\t}\n}\n\n.crumb_current {\n\tfont-size: 12px;\n\tcolor: #0e0a40;\n\tfont-weight: 600;\n\tcursor: not-allowed;\n}\n\n.left_edge {\n\twidth: 15vw;\n}\n\n.row {\n\tdisplay: flex;\n\talign-items: center;\n}\n\n.center {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n}\n\n.column_center {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n}\n\n.space-between {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n}\n\n.space-between-no-center {\n\tdisplay: flex;\n\tjustify-content: space-between;\n}\n\n.flex-end {\n\twidth: 100%;\n\tdisplay: flex;\n\tjustify-content: flex-end;\n}\n\n.flex-end-center {\n\twidth: 100%;\n\tdisplay: flex;\n\tjustify-content: flex-end;\n\talign-items: center;\n}\n\nh2 {\n\tfont-size: 30px;\n\tcolor: #0e0a40;\n\tfont-weight: 800;\n}\n\nstrong {\n\tpadding-right: 7px;\n}\n\n.login_logo {\n\tposition: absolute;\n\twidth: 150px;\n\tleft: 20px;\n\ttop: 20px;\n}\n\n.main_container {\n\toverflow-y: scroll;\n\theight: calc(100vh - 100px);\n}\n\n/* Buttons */\n.primary {\n\tbackground-color: #fd552b;\n\tcolor: #ffffff;\n\tfont-size: 0.9rem;\n}\n\n.login_btn {\n\tbackground: rgb(253, 85, 43);\n\tbackground: -moz-linear-gradient(270deg,\n\t\t\trgba(253, 85, 43, 1) 0%,\n\t\t\trgba(253, 85, 43, 1) 74%,\n\t\t\trgba(253, 43, 124, 1) 100%);\n\tbackground: -webkit-linear-gradient(270deg,\n\t\t\trgba(253, 85, 43, 1) 0%,\n\t\t\trgba(253, 85, 43, 1) 74%,\n\t\t\trgba(253, 43, 124, 1) 100%);\n\tbackground: linear-gradient(270deg,\n\t\t\trgba(253, 85, 43, 1) 0%,\n\t\t\trgba(253, 85, 43, 1) 74%,\n\t\t\trgba(253, 43, 124, 1) 100%);\n\tfilter: progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#fd552b\", endColorstr=\"#fd2b7c\", GradientType=1);\n\tcolor: #ffffff;\n}\n\n.primary:hover {\n\tbackground: #c64422;\n}\n\n.secondary {\n\tbackground-color: #edeef4;\n\tcolor: #000000;\n\tfont-weight: 600;\n}\n\n.secondary:hover {\n\tbackground: #dddddd;\n}\n\n.tertiary {\n\tbackground-color: #9facc7;\n\tcolor: #ffffff;\n}\n\n.success:hover {\n\tbackground-color: #259679;\n}\n\n.success {\n    background-color: #2bb992;\n    color: #ffffff;\n}\n\n.white {\n\tbackground-color: #ffffff;\n}\n\n.btn_lg {\n\theight: 41px !important;\n}\n\n.with_tooltip:hover+.tooltip_black {\n\tdisplay: block;\n}\n\n.tooltip_black {\n\tdisplay: none;\n\tmargin-top: 0.5rem;\n\tbackground-color: rgba(0, 0, 0, 0.35);\n\tcolor: white;\n\tpadding: 7px;\n\tborder-radius: 5px;\n\tfont-family: Montserrat, sans-serif;\n\tfont-size: 12px;\n}\n\n.onboarding_input_grid {\n\tdisplay: grid;\n\tgrid-template-columns: 1fr 1fr 1fr 1fr;\n\tgrid-gap: 10px;\n\tposition: relative;\n}\n\n.onboarding_btn {\n\tposition: absolute;\n\tright: -50px;\n\ttop: 41px;\n}\n\n.onboarding_branch_grid {\n\tdisplay: grid;\n\tgrid-template-columns: 0.8fr 0.8fr 0.8fr 1.6fr;\n\tgrid-gap: 10px;\n\tposition: relative;\n}\n\n.onboarding_link {\n\tcursor: pointer;\n\tfont-size: 14px;\n\tcolor: #8f9bb3;\n\tmargin-right: 1rem;\n}\n\n.onboarding_save_btn {\n\tmin-width: 66px;\n\tpadding-left: 7px;\n\tpadding-right: 7px;\n\theight: 40px;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tfont-size: 14px;\n\tbackground-color: rgba(143, 155, 179, 0.12);\n\tborder: 1px solid #9da9c4;\n\tborder-radius: 5px;\n\tcolor: #9da9c4;\n\tmargin-right: 1rem;\n}\n\n.onboarding_save_btn:hover {\n\tbackground-color: rgba(143, 155, 179, 0.3);\n}\n\n/* Chrome, Safari, Edge, Opera */\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n\t-webkit-appearance: none;\n\tmargin: 0;\n}\n\n/* Firefox */\ninput[type=\"number\"] {\n\t-moz-appearance: textfield;\n}\n\n.chart_blocker {\n\twidth: 100%;\n\theight: 100%;\n\tbackground-color: transparent;\n\tposition: absolute;\n\tz-index: 9999;\n}\n\n.input_number_box {\n\tposition: relative;\n}\n\n.arrow_up {\n\twidth: 25px;\n\theight: 23px;\n\tbackground-color: rgba(228, 233, 242, 0.77);\n\tposition: absolute;\n\tright: 1px;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\ttop: 1px;\n\tcursor: pointer;\n\tborder-radius: 0px 5px 0 0px;\n}\n\n.arrow_bottom {\n\twidth: 25px;\n\theight: 23px;\n\tbackground-color: rgba(228, 233, 242, 0.77);\n\tposition: absolute;\n\tright: 1px;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\ttop: 26px;\n\tcursor: pointer;\n\tborder-radius: 0px 0px 5px 0px;\n}\n\n.arrow_bottom>img {\n\ttransform: rotateZ(-180deg);\n}\n\n/* Text classes */\n.rem-08 {\n\tfont-size: 0.8rem;\n}\n\n.text-center {\n\ttext-align: center;\n}\n\n.text-right {\n\ttext-align: right;\n}\n\n.employee_header_row {\n\tdisplay: flex;\n\tjustify-content: flex-end;\n\talign-items: center;\n}\n\n.min-w {\n\twidth: min-content;\n}\n\n.dashboard_box_padding {\n\twidth: 100%;\n\theight: 100%;\n\tpadding: 29px 42px 36px 25px;\n\tposition: relative;\n}\n\n@media (max-width: 600px) {\n\t.dashboard_box_padding {\n\t\tpadding: 16px;\n\t}\n\n\t.employee_header_row {\n\t\tdisplay: flex;\n\t\tjustify-content: flex-end;\n\t\twidth: 100%;\n\t}\n}\n\n.select-react div.control {\n\theight: 50px;\n\tborder: 1px solid #cde1eb;\n}\n\n.line {\n\tposition: relative;\n\twidth: 100%;\n\theight: 1px;\n\tbackground-color: #e3ecff;\n\tmargin-top: 10px;\n\tmargin-bottom: 35px;\n}\n\n.line_element {\n\tposition: absolute;\n\tleft: 0;\n\ttop: -1px;\n\twidth: 40px;\n\theight: 3px;\n\tbackground-color: #e0e9f5;\n}\n\n.table_line {\n\tmargin-bottom: 27px;\n}\n\n.table_row {\n\tfont-family: Montserrat, sans-serif;\n\twidth: 100%;\n\theight: 74px;\n\talign-items: center;\n\tborder: 1px solid #f3f3f3;\n\tpadding: 15px;\n\tfont-size: 16px;\n\tfont-weight: 500;\n\tborder-radius: 4px;\n\tmargin-bottom: 4px;\n\tcolor: #000000;\n}\n\n.standard-padding-l {\n\tpadding-left: 40px;\n}\n\n.standard-margin-l {\n\tmargin-left: 40px;\n}\n\n/* SEARCH BOX */\n.search_container {\n\tmin-width: 450px;\n\tborder-radius: 11px 10px 10px 11px;\n\tdisplay: flex;\n\tposition: relative;\n}\n\n@media (max-width: 900px) {\n\t.search_container {\n\t\twidth: 100%;\n\t\tmin-width: 200px;\n\t\tborder-radius: 11px 10px 10px 11px;\n\t\tdisplay: flex;\n\t}\n}\n\n@media (max-width: 700px) {\n\t.header_orders {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: flex-start;\n\t}\n}\n\n.dark_search {\n\theight: 45px;\n\tbackground-color: #edeef4;\n}\n\n.light_search {\n\theight: 47px;\n\tbackground-color: #ffffff;\n\tborder: 1px #e3e5f1 solid;\n}\n\n.search_container input::placeholder {\n\tfont-family: \"Montserrat\", sans-serif;\n\tfont-size: 12px;\n\tfont-weight: 500;\n\tcolor: rgba(124, 130, 138, 0.38);\n}\n\n.search_button {\n\theight: 45px;\n\twidth: 50px;\n\tbackground-color: rgba(81, 93, 167, 0.16);\n\tborder-radius: 10px;\n\tcursor: pointer;\n}\n\n.search_clear_button {\n\theight: 20px;\n\twidth: 20px;\n\tbackground-color: rgba(81, 93, 167, 0.16);\n\tborder-radius: 50%;\n\tcursor: pointer;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tposition: absolute;\n\tright: 20px;\n\ttop: 12px;\n}\n\n.search_clear_button>img {\n\twidth: 8px;\n\theight: 8px;\n}\n\n.search_container input {\n\twidth: 100%;\n\t-webkit-appearance: none;\n\tborder: none;\n\tbackground-color: transparent;\n\tfont-size: 14px;\n\tpadding-left: 15px;\n\tcolor: rgba(124, 130, 138, 1);\n}\n\n.header_search_responsive_show {\n\tdisplay: none;\n}\n\n.header_search_responsive_hide {\n\tdisplay: none;\n}\n\n.search_icon {\n\twidth: 18px;\n\theight: 18px;\n}\n\n/* UPLOAD IMAGE COMPONENT */\n\n.pdf_upload {\n\tmin-width: 205px;\n\twidth: fit-content;\n\tposition: relative;\n\tcursor: pointer;\n\tborder-radius: 7px;\n}\n\n.pdf_upload:hover {\n\tbackground: #c64422\n}\n\n.pdf_upload_image {\n\twidth: 200px;\n\theight: 200px;\n\tbackground-size: cover;\n\tbackground-position: center;\n}\n\n\n.image_upload {\n\tposition: relative;\n\twidth: 262px;\n\theight: 262px;\n\tborder-radius: 50%;\n\tborder: 2px solid #dee1e7;\n\tbackground-size: cover;\n\tbackground-position: center;\n}\n\n@media (max-width: 450px) {\n\t.image_upload-center {\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t}\n}\n\n.upload_image {\n\tposition: absolute;\n\twidth: 100%;\n\theight: 100%;\n\tborder-radius: 50%;\n\tbackground-size: contain;\n\tbackground-position: center;\n\tbackground-repeat: no-repeat;\n\ttop: 0;\n\tleft: 0;\n}\n\n.upload_user {\n\tposition: absolute;\n\twidth: 100%;\n\theight: 100%;\n\tborder-radius: 50%;\n\tbackground-size: cover;\n\tbackground-repeat: no-repeat;\n\ttop: 0;\n\tleft: 0;\n}\n\n.hide-file-input {\n\tposition: absolute;\n\twidth: 58px;\n\theight: 58px;\n\tborder-radius: 50%;\n\tright: 0;\n\tz-index: 2;\n\topacity: 0;\n}\n\n.hide-file-input:hover {\n\tcursor: \"pointer\"\n}\n\n.custom_file_input {\n\tposition: absolute;\n\twidth: 58px;\n\theight: 58px;\n\tborder-radius: 50%;\n\tbackground-color: #9facc7;\n\tright: 0;\n\tz-index: 1;\n}\n\n.custom_file_input>img {\n\twidth: 25px;\n}\n\n.side_product_title {\n\tfont-size: 16px;\n\tpadding-left: 15px;\n\tfont-weight: 700;\n}\n\n.plans_wrapper {\n\twidth: 100%;\n\tmax-width: 1400px;\n}\n\n.invoice-status {\n\tcolor: rgba(51, 51, 51, 1);\n\tfont-weight: 700;\n\tfont-size: 22px;\n\tborder-bottom: 2px solid #e0e0e7;\n\tpadding-bottom: 10px;\n    margin-bottom: 20px;\n}\n\n.invoice_comment_container {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-top: 7px;\n    background-color: rgba(13, 150, 131, 0.08);\n    padding: 7px;\n    border-radius: 5px;\n}\n\n.invoice_comment_container > p {\n    font-size: 14px;\n}\n\n.invoice_comment_container > div {\n    max-width: 300px;\n    font-size: 12px;\n    text-align: end;\n}\n\n.invoice-ocr-error {\n    display: flex;\n    align-content: center;\n    gap: 3px;\n    margin-top: 14px;\n}\n\n.invoice-ocr-comment {\n    margin-top: 20px;\n}\n\n.invoice-ocr-comment > div {\n    display: flex;\n    align-items: center;\n    gap: 14px;\n}\n\n.invoice-ocr-comment > div > div > p:first-child {\n    font-size: 14px;\n    font-weight: bold;\n    display: flex;\n    align-items: center;\n}\n\n.invoice-ocr-comment > div > div > p:first-child > span {\n    font-size: 12px;\n    font-weight: normal;\n    margin-left: 7px;\n    color: #0d9683;\n}\n\n.invoice-ocr-comment > div > div > p:last-child {\n    font-size: 14px;\n    margin-top: 5px;\n}\n\n.invoice-ocr-comment-tooltip {\n    height: 20px;\n}\n\n.invoice-ocr-error > img {\n    width: 16px;\n    height: 16px;\n    /*margin-top: auto;\n    margin-bottom: auto;*/\n}\n\n.invoice-ocr-error > p {\n    font-size: 14px;\n    color: rgba(222, 57, 73, 1);\n    margin-bottom: 0;\n}\n\n.invoice_detail_value {\n    font-size: 18px;\n    font-weight: 400;\n}\n\n.invoice_detail_title {\n    font-size: 14px;\n    font-weight: 400;\n}\n\n.invoice_detail_next_btn {\n    height: 40px;\n    display: flex;\n    align-items: center;\n    padding-left: 15px;\n    padding-right: 15px;\n    background-color: rgba(156, 154, 167, 1);\n    border-radius: 5px;\n    color: #FFFFFF;\n}\n\n.invoice_detail_next_btn:hover {\n    background-color: rgb(121, 119, 131);\n}\n\n.invoice_detail_next_btn > img {\n    width: 24px;\n}\n\n.invoice_detail_next_btn > p {\n    font-size: 14px;\n    font-weight: 500;\n    margin-left: 5px;\n}\n\n.invoice_detail_value_bold {\n    font-size: 20px;\n    font-weight: 700;\n}\n\n.invoice_image {\n\twidth: 90%;\n}\n\n.invoice-header {\n\tcolor: #001940;\n\tfont-size: 1.2rem;\n\tfont-weight: 700;\n\tdisplay: flex;\n\tjustify-content: space-between;\n\tborder-bottom: 1px solid #e0e0e7;\n\tpadding-bottom: 10px;\n}\n\n.invoice-data {\n\tcolor: #001940;\n\tfont-size: 1rem;\n\tfont-weight: 400;\n\tdisplay: flex;\n\tjustify-content: space-between;\n}\n\n.invoice-amount {\n\tcolor: #767493;\n\tfont-size: 1rem;\n\tfont-weight: 400;\n\tdisplay: flex;\n\tjustify-content: space-between;\n\tline-height: 37px;\n}\n\n.csv_reader {\n\tposition: absolute;\n\tleft: 0;\n\ttop: 0;\n}\n\n.csv_label {\n\tdisplay: none;\n}\n\n.csv_upload_wrapper {\n\tbackground-color: #f0b619;\n\twidth: 100%;\n\theight: 40px;\n\topacity: 0;\n}\n\n.csv_btn {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n}\n\n/* COLORS */\n.red {\n\tbackground-color: red;\n}\n\n.green {\n\tbackground-color: #00c18d;\n}\n\n/* SIZES */\n.pc80 {\n\twidth: 80%;\n}\n\n/* FONTS */\nh4 {\n\tfont-size: 16px;\n\tfont-family: \"Montserrat\", sans-serif;\n\tfont-weight: 600;\n\tcolor: #292452;\n}\n\n/* SHADOW */\n.shadow {\n\t-webkit-box-shadow: rgba(149, 157, 165, 0.2) 0 8px 24px;\n\tbox-shadow: rgba(149, 157, 165, 0.2) 0 8px 24px;\n}\n\n.input_error {\n\tfont-size: 14px;\n\ttext-align: right;\n\tmargin-top: -15px;\n\tcolor: rgba(151, 57, 55, 0.7);\n}\n\n.input_warning {\n\tposition: absolute;\n\tfont-size: 10px;\n\ttext-align: left;\n\tbottom: -1px;\n\tcolor: rgba(151, 57, 55, 0.7);\n}\n\n/* TOASTS */\n.Toastify__toast--success {\n\tbackground: rgb(222, 242, 214);\n\tcolor: rgb(130, 105, 56);\n}\n\n.Toastify__toast--warning {\n\tbackground: rgb(248, 243, 215);\n\tcolor: rgb(140, 57, 58);\n}\n\n.Toastify__toast--error {\n\tbackground: rgb(235, 200, 196);\n\tcolor: rgb(90, 110, 82);\n}\n\n.Toastify__close-button>svg {\n\tfill: rgb(140, 57, 58);\n}\n\n@media (max-width: 800px) {\n\t.pending_box {\n\t\tmax-width: 96vw;\n\t}\n}\n\n.header_plans {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n}\n\n@media (max-width: 700px) {\n\t.header_plans {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: flex-start;\n\t\tgap: 10px;\n\t}\n}\n\n.companies_sub_title {\n\ttext-align: center;\n\tmargin-top: 0.5rem;\n\tfont-size: 14px;\n\tcolor: #37454d;\n}\n\n.companies_table_container {\n\tmargin-top: 3rem;\n\tbackground-color: white;\n\tpadding-top: 3rem;\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tpadding-bottom: 3rem;\n}\n\n.companies_table_container>img {\n\twidth: 300px;\n\tmax-width: 50vw;\n}\n\n.companies_table_container>h3 {\n\tmargin-top: 1rem;\n\tfont-size: 18px;\n\tfont-weight: 600;\n}\n\n.companies_table_container>p {\n\tmargin-top: 0.5rem;\n\tfont-size: 14px;\n\tfont-weight: 500;\n\tcolor: #37454d;\n}\n\n.oboarding_container {\n\tmax-width: 860px;\n\tmargin-left: auto;\n\tmargin-right: auto;\n}\n\n.onboarding_sub_title {\n\tfont-size: 11px;\n\tcolor: #333333;\n}\n\n.space-between_onboarding {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\tborder-bottom: 1px solid rgba(143, 155, 179, 0.26);\n\tpadding-bottom: 0.5rem;\n}\n\n/*.settings_tab {\n    margin-top: 30px;\n}*/\n\n.perm_table_box {\n\tbackground-color: white;\n}\n\n.sub_title {\n\tfont-size: 16px;\n\tfont-weight: 500;\n\tcolor: rgba(0, 0, 0, 0.8);\n}\n\n@media (max-width: 700px) {\n\t.sub_title {\n\t\tmax-width: 40vw;\n\t\tmargin-bottom: 1rem;\n\t\tfont-size: 12px;\n\t}\n}\n\n.space-between_plans {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n}\n\n@media (max-width: 450px) {\n\t.space-between_plans {\n\t\tdisplay: block;\n\t}\n}\n\n.employee_select_row {\n\tdisplay: flex;\n\talign-items: center;\n}\n\n@media (max-width: 600px) {\n\t.employee_select_row {\n\t\tdisplay: block;\n\t}\n}\n\n.form_radio input[type=\"radio\"] {\n\tdisplay: none;\n}\n\n.form_radio label {\n\tdisplay: inline-block;\n\tcursor: pointer;\n\tposition: relative;\n\tpadding-left: 25px;\n\tmargin-right: 0px;\n\tline-height: 18px;\n\tuser-select: none;\n\tfont-size: 14px;\n}\n\n.form_radio label:before {\n\tcontent: \"\";\n\tdisplay: inline-block;\n\twidth: 16px;\n\tmin-width: 14px;\n\tmin-height: 14px;\n\tmax-width: 14px;\n\tmax-height: 14px;\n\theight: 16px;\n\tposition: absolute;\n\tleft: 0;\n\tbottom: 1px;\n\tborder-radius: 50%;\n\tborder: 1px solid #767493;\n}\n\n.customReactSelectMenu {\n\tbackground-color: white;\n}\n\n.permission_select_btn_box {\n\twidth: 100%;\n\tpadding: 10px;\n}\n\n/* Checked */\n.form_radio input[type=\"radio\"]:checked+label:before {\n\tbackground: radial-gradient(#767493 50%, rgba(255, 0, 0, 0) 51%);\n}\n\n/* Hover */\n.form_radio label:hover:before {\n\tfilter: brightness(120%);\n}\n\n/* Disabled */\n.form_radio input[type=\"radio\"]:disabled+label:before {\n\tfilter: grayscale(100%);\n}\n\n.cookie_container {\n\tpadding-left: 20%;\n\tpadding-right: 20%;\n\tmin-height: 200px;\n\tcolor: white;\n\tbackground-color: #070948 !important;\n\tpadding-top: 20px;\n}\n\n.cookie_title {\n\tfont-size: 16px;\n\tfont-weight: 600;\n}\n\n.cookie_text {\n\tfont-size: 12px;\n\tmargin-top: 1rem;\n}\n\n.cookie_link {\n\tcolor: #f67b44;\n\ttext-decoration: none;\n\tfont-weight: 600;\n}\n\n.cookie_button {\n\tposition: absolute;\n\tbottom: 20px;\n\tbackground-color: #f67b44 !important;\n\tcolor: white !important;\n\tborder-radius: 30px !important;\n\tfont-weight: 600;\n\tpadding: 10px 15px 10px 15px !important;\n}\n\n@media (max-width: 900px) {\n\t.cookie_button {\n\t\tposition: relative;\n\t}\n}\n\n@media (max-width: 700px) {\n\t.cookie_container {\n\t\tpadding-left: 16px;\n\t\tpadding-right: 16px;\n\t}\n}\n\n.footer_link {\n\tposition: absolute;\n\tbottom: 10px;\n\tfont-size: 12px;\n\tfont-weight: 600;\n\tcolor: white;\n\ttext-decoration: none;\n\tmargin-left: 1rem;\n}\n\n@media (max-width: 700px) {\n\thtml {\n\t\tfont-size: 70%;\n\t}\n}\n\n.update_info_arrow {\n\twidth: 10px;\n\tmargin-left: 5px;\n\tmargin-right: 5px;\n}\n\n.update_info_img {\n\tmin-width: 40px;\n\tmin-height: 40px;\n\twidth: 40px;\n\theight: 40px;\n\tborder-radius: 50%;\n\tbackground-color: black;\n\tbackground-size: cover;\n}\n\n.update_info_img.small {\n\tmin-width: 30px;\n\tmin-height: 30px;\n\twidth: 30px;\n\theight: 30px;\n}\n\n.invoice_status_box {\n\tposition: relative;\n\tmargin-right: 0.5rem;\n}\n\n.badge {\n\twidth: max-content;\n\tpadding: 5px 10px;\n\tborder-radius: 3px;\n\tfont-weight: 600;\n\tletter-spacing: 0.5px;\n}\n\n.accept_badge {\n\tbackground-color: rgba(0, 182, 155, 0.25);\n\tcolor: #0d9683;\n}\n\n.yellow_badge {\n\tbackground-color: #FFF3CD;\n\tcolor: #856404;\n}\n\n.blue_badge {\n\tbackground-color: #CCE5FF;\n\tcolor: #004085;\n}\n\n.status_dot {\n\twidth: 15px;\n\theight: 15px;\n\tborder-radius: 50%;\n\tmargin-left: auto;\n\tmargin-right: 8px;\n\tfloat: left;\n}\n\n.status_dot.red {\n\tbackground-color: #ff0033;\n}\n\n.status_dot.green {\n\tbackground-color: #50C878;\n}\n\n.status_dot.yellow {\n\tbackground-color: #FFC33C;\n}\n\n.pending_badge {\n\tcolor: #f2a338;\n\tbackground-color: rgba(255, 236, 206, 0.8);\n}\n\n.reject_badge {\n\tcolor: #e56a5f;\n\tbackground-color: rgba(255, 162, 157, 0.5);\n}\n\n.badge.small {\n\twidth: max-content;\n\tpadding: 2px 5px;\n\tborder-radius: 2px;\n\tfont-weight: 600;\n\tletter-spacing: 0.2px;\n\tfont-size: 11px;\n}\n\n.notification_mark_text {\n\tfont-size: 12px;\n\tfont-weight: 600;\n\tcursor: pointer;\n\tcolor: #1ec0a6;\n}\n\n/* Rounded sliders */\n.slider_switch.round {\n\tborder-radius: 34px;\n\t-webkit-box-shadow: rgba(149, 157, 165, 0.4) 0 8px 24px;\n\tbox-shadow: rgba(149, 157, 165, 0.4) 0 8px 24px;\n}\n\n.slider_switch.round:before {\n\tborder-radius: 50%;\n}\n\n.text_area {\n\tborder: 1px solid rgba(14, 10, 64, 0.15);\n\tborder-radius: 5px;\n\tresize: none;\n\tpadding: 10px;\n\tfont-size: 14px;\n\tfont-family: Montserrat;\n    margin-left: 0!important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
